import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

// Legacy route: the "no fui yo" email now goes directly to /recuperar-cuenta.
// This page exists only as a bridge for old emails still in inboxes.
export default function SecurityItWasntMe() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";

  useEffect(() => {
    try { localStorage.removeItem("hittcg_token"); } catch (e) { /* noop */ }
    // Bridge legacy `?token=` → new `?revoke_token=`
    const target = token ? `/recuperar-cuenta?revoke_token=${encodeURIComponent(token)}` : "/recuperar-cuenta";
    nav(target, { replace: true });
  }, [token, nav]);

  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center">
      <div className="flex justify-center mb-8"><Logo /></div>
      <p className="text-neutral-400 text-sm">Redirigiendo a la recuperación segura de tu cuenta…</p>
    </div>
  );
}
